import { render } from "./TimelineNr2.vue?vue&type=template&id=0a51bd7a&scoped=true"
import script from "./TimelineNr2.vue?vue&type=script&lang=js"
export * from "./TimelineNr2.vue?vue&type=script&lang=js"

import "./TimelineNr2.vue?vue&type=style&index=0&id=0a51bd7a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a51bd7a"]])

export default __exports__